import { createAction, props } from '@ngrx/store';
import { PrescriptionEntity } from './prescription.models';
import {
  PrescriptionDTO,
  UpdatePrescriptionDTO,
  Prescription,
  LoadType,
  Fulfillment
} from '@care-portals/api-interfaces';

export const loadPrescriptions = createAction(
  '[Prescription] Load All Prescriptions',
  props<{ loadType: LoadType; filters: any }>()
);

export const loadPrescriptionsSuccess = createAction(
  '[Prescription] Load Prescriptions Success',
  props<{ prescriptions: PrescriptionEntity[]; loadType: LoadType }>()
);

export const loadPrescriptionsFailure = createAction(
  '[Prescription] Load Prescriptions Failure',
  props<{ error: any }>()
);

export const fetchPrescription = createAction(
  '[Prescription] Fetch Prescription',
  props<{ prescriptionId: string }>()
);

export const fetchPrescriptionSuccess = createAction(
  '[Prescription] Fetch Prescription Success',
  props<{ prescription: PrescriptionEntity }>()
);

export const fetchPrescriptionFailure = createAction(
  '[Prescription] Fetch Prescription Failure',
  props<{ error: any }>()
);

export const createPrescription = createAction(
  '[Prescription] Create Prescription',
  props<{
    prescription: PrescriptionDTO;
    orderId?: number;
    sendRx?: boolean;
  }>()
);

export const createPrescriptionSuccess = createAction(
  '[Prescription] Create Prescription Success',
  props<{
    prescription: PrescriptionEntity;
    orderId?: number;
    sendRx?: boolean;
  }>()
);

export const createPrescriptionFailure = createAction(
  '[Prescription] Create Prescription Failure',
  props<{ error: any }>()
);

export const updatePrescription = createAction(
  '[Prescription] Update Prescription',
  props<{
    id: string;
    data: UpdatePrescriptionDTO;
    /** When set, success handling (toast + optional transfer-out) runs in prescription effects. */
    linkToOrderContext?: {
      orderId: number;
      transferOutAfterLink: boolean;
    };
  }>()
);

export const addFulfillment = createAction(
  '[Prescription] Add Fulfillment',
  props<{ id: string; fulfillment: Fulfillment }>()
);

export const addFulfillmentSuccess = createAction(
  '[Prescription] Add Fulfillment Success',
  props<{ prescription: PrescriptionEntity; orderId: number }>()
);

export const addFulfillmentFailure = createAction(
  '[Prescription] Add Fulfillment Failure',
  props<{ error: any }>()
);

export const updatePrescriptionSuccess = createAction(
  '[Prescription] Update Prescription Success',
  props<{
    prescription: PrescriptionEntity;
    linkToOrderContext?: {
      orderId: number;
      transferOutAfterLink: boolean;
    };
  }>()
);

export const updatePrescriptionFailure = createAction(
  '[Prescription] Update Prescription Failure',
  props<{ error: any; id: string }>()
);

export const sendRx = createAction(
  '[Prescription] Send Rx',
  props<{ rxId: string }>()
);

export const sendRxSuccess = createAction(
  '[Prescription] Send Rx Success',
  props<{ prescription: any; orderCreated?: boolean }>()
);

export const sendRxFailure = createAction(
  '[Prescription] Send Rx Failure',
  props<{ error: any }>()
);

export const resetRx = createAction('[Prescription] Reset Rx');

export const downloadPrescriptionPdf = createAction(
  '[Prescription] Download Prescription PDF',
  props<{ rxId: string }>()
);

export const downloadPrescriptionPdfSuccess = createAction(
  '[Prescription] Download Prescription PDF Success',
  props<{ signedUrl: string }>()
);

export const downloadPrescriptionPdfFailure = createAction(
  '[Prescription] Download Prescription PDF Failure',
  props<{ error: string }>()
);

export const resetFulfillmentState = createAction(
  '[Prescription] Reset Fulfillment State'
);

export const createPrescriptionWithSendRxComplete = createAction(
  '[Prescription] Create Prescription With Send Rx Complete'
);

export const sendPrescriptionPdfToChat = createAction(
  '[Prescription] Send Prescription PDF To Chat',
  props<{ rxId: string; orderId?: number }>()
);

export const sendPrescriptionPdfToChatSuccess = createAction(
  '[Prescription] Send Prescription PDF To Chat Success',
  props<{ rxId: string }>()
);

export const sendPrescriptionPdfToChatFailure = createAction(
  '[Prescription] Send Prescription PDF To Chat Failure',
  props<{ rxId: string; error: any }>()
);
